import { Button } from "primereact/button";
import localeText from "../../../../locale";
import useButtonAddToCart from "../../hooks/useButtonAddToCart";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import IntegrationService from "../../../../service/IntegrationService";
import GetUserInfoService from "../../../../service/GetUserInfoService";
import "./styles.css";
import { useLocation } from "react-router-dom";

const integrationService = new IntegrationService();
const getUserInfoService = new GetUserInfoService();

const ButtonAddToCart = ({
  productInfo,
  currentVariation,
  currentAttribute1Value,
  currentAttribute2Value,
  productQty,
}) => {
  const { showErrorToast } = useToastContext();
  const locationUrl = useLocation();

  const isFringeBenefitsPage = locationUrl?.pathname?.toLowerCase()?.includes("fringe");

  const { addToCart, loadingOrder } = useButtonAddToCart({
    currentVariation: currentVariation,
    currentAttribute1Value,
    currentAttribute2Value,
    productQty,
    productInfo,
    onErrorAddToCart: (code) => showErrorToast({ code }),
    onErrorDownloadableAndNonDownloadable: () =>
      showErrorToast({
        detail: "downloadableAndNonDownloadable",
      }),
    onErrorData: (code) => showErrorToast({ code }),
    onErrorItemAlreadyInCart: () => showErrorToast({ detail: "itemAlreadyInCart" }),
    onErrorOneSeller: () => showErrorToast({ detail: "onlyOneSeller" }),
  });

  const { product } = productInfo.data;

  const isDisabled = loadingOrder ? "opacity-80 pointer-events-none" : "";
  const buttonClass = `uppercase font-bold text-sm py-3 px-4 w-full product-info-button border-none border-round-md ${isDisabled}`;

  async function getUserInfo() {
    let info = await getUserInfoService.getUserInfo(
      localStorage.getItem("__extraconomy_token"),
      localStorage.getItem("__extraconomy_username")
    );
    sendAddCart(info.result.user);
  }

  async function sendAddCart(user) {
    let dataLayer = window.dataLayer || [];

    dataLayer.push({
      event: "AddCart",
    });

    let ip = await integrationService.getUserIp();

    let date = new Date();

    let payload = {
      eventData: {
        currency: "",
        value: 0,
      },
      eventName: "AddCart",
      eventTime: Math.floor(date.getTime() / 1000),
      userData: {
        email: user ? user.email : "",
        ipAddress: ip.data.ip,
        phone: "",
        userAgent: window.navigator.userAgent,
      },
    };

    let res = await integrationService.sendEvent(payload);
    return res;
  }

  const addCart = () => {
    localStorage.getItem("__extraconomy_token") ? getUserInfo() : sendAddCart(null);
    addToCart();
  };

  if (product?.user?.username === localStorage.getItem("__extraconomy_username")) {
    return (
      <Button
        label={localeText("buyNow")}
        className={`${buttonClass}`}
        onClick={() => showErrorToast({ detail: "errorThisProductIsYours" })}
        loading={loadingOrder}
      />
    );
  }

  if (isFringeBenefitsPage) {
    return (
      <Button
        label={localeText("buyNow")}
        className={buttonClass}
        onClick={addCart}
        loading={loadingOrder}
      />
    );
  }

  return (
    <>
      {!product.downloadable && !product.service ? (
        <Button
          label={
            !currentVariation && productInfo.data.attributes.length === 1
              ? `${localeText("selectOneAttribute")} "${productInfo.data.attributes[0].attribute}"`
              : !currentVariation && productInfo.data.attributes.length === 2
              ? `${localeText("selectTwoAttributes")} "${
                  productInfo.data.attributes[0].attribute
                }" ${localeText("and")} "${productInfo.data.attributes[1].attribute}"`
              : localeText("buyNow")
          }
          className={buttonClass}
          disabled={
            (productInfo.data.productVariations.length > 0 &&
              ((productInfo.data.attributes.length === 2 &&
                !(currentAttribute1Value && currentAttribute2Value)) ||
                (productInfo.data.attributes.length === 1 && !currentAttribute1Value))) ||
            product.amountInStock === 0 ||
            (currentVariation && currentVariation.amountInStock === 0) ||
            (productInfo.data.attributes.length > 0 &&
              productInfo.data.productVariations.length === 0) ||
            productQty === 0
          }
          onClick={addCart}
          loading={loadingOrder}
        />
      ) : (
        <Button
          label={localeText("buyNow")}
          className={buttonClass}
          onClick={addCart}
          loading={loadingOrder}
        />
      )}
    </>
  );
};

export default ButtonAddToCart;
